import { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import { Button } from "@mui/material";

import { CompanyForm } from "@/features/companies";
import { mapEntityTaxInformationToFormValues } from "@/features/entity-tax-information";
import { apiClient, getErrorMessage } from "@/features/shared";
import { PageContainer, useSnackbar } from "@/features/ui";

export const EditCompany = () => {
  const { companyId } = useParams();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    const fetchCompany = async () => {
      setIsLoading(true);
      try {
        const {
          data: { data },
        } = await apiClient.get(`companies/${companyId}`, {
          params: {
            withEntityTaxInformation: true,
          },
        });

        setDefaultValues({
          name: data.name,
          status: data.status,
          ...mapEntityTaxInformationToFormValues(data.entityTaxInformation),
        });
      } catch (error) {
        showSnackbar(
          getErrorMessage(error, "Gagal memperbarui perusahaan")
        );
      } finally {
        setIsLoading(false);
      }
    };
    fetchCompany();
  }, [companyId, showSnackbar]);

  const handleSubmit = async (formData) => {
    try {
      await apiClient.put(`companies/${companyId}`, formData);
      navigate(-1);
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal memperbarui perusahaan"));

      showSnackbar(
        getErrorMessage(error, "Gagal memperbarui perusahaan")
      );
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Ubah Perusahaan"
      breadcrumbs={[
        { title: "Perusahaan", path: "/setting/companies" },
        { title: "Ubah" },
      ]}
    >
      <CompanyForm
        isLoading={isLoading}
        defaultValues={defaultValues}
        onSubmit={handleSubmit}
        renderActionButton={({ isSubmitting }) => (
          <Button type="submit" variant="contained" loading={isSubmitting}>
            Simpan
          </Button>
        )}
      />
    </PageContainer>
  );
};
